// Chat-related root state.

export default {
  channels: [],
  activeChannelId: null,
  messages: {},
  threadOpen: false,
  threadParentId: null,
  _chatDrawerOpen: false
}
